__turbopack_context__.v({
  "backButton": "Navigation-module__1DahEa__backButton",
  "chevronIcon": "Navigation-module__1DahEa__chevronIcon",
  "container": "Navigation-module__1DahEa__container",
  "containerRegular": "Navigation-module__1DahEa__containerRegular",
  "containerSmall": "Navigation-module__1DahEa__containerSmall",
  "containerTripOverview": "Navigation-module__1DahEa__containerTripOverview",
  "desktopActions": "Navigation-module__1DahEa__desktopActions",
  "dropdown": "Navigation-module__1DahEa__dropdown",
  "dropdownChevron": "Navigation-module__1DahEa__dropdownChevron",
  "dropdownChevronExpanded": "Navigation-module__1DahEa__dropdownChevronExpanded",
  "dropdownContent": "Navigation-module__1DahEa__dropdownContent",
  "dropdownCountry": "Navigation-module__1DahEa__dropdownCountry",
  "dropdownCountryItem": "Navigation-module__1DahEa__dropdownCountryItem",
  "dropdownHeader": "Navigation-module__1DahEa__dropdownHeader",
  "dropdownHidden": "Navigation-module__1DahEa__dropdownHidden",
  "dropdownLink": "Navigation-module__1DahEa__dropdownLink",
  "dropdownLinkActive": "Navigation-module__1DahEa__dropdownLinkActive",
  "dropdownLinkActiveMobile": "Navigation-module__1DahEa__dropdownLinkActiveMobile",
  "dropdownLinkFocused": "Navigation-module__1DahEa__dropdownLinkFocused",
  "dropdownLinkText": "Navigation-module__1DahEa__dropdownLinkText",
  "dropdownLinkTextActive": "Navigation-module__1DahEa__dropdownLinkTextActive",
  "dropdownLinkTextExpanded": "Navigation-module__1DahEa__dropdownLinkTextExpanded",
  "dropdownList": "Navigation-module__1DahEa__dropdownList",
  "dropdownListItem": "Navigation-module__1DahEa__dropdownListItem",
  "dropdownTile": "Navigation-module__1DahEa__dropdownTile",
  "dropdownTileContent": "Navigation-module__1DahEa__dropdownTileContent",
  "dropdownTileImage": "Navigation-module__1DahEa__dropdownTileImage",
  "dropdownTileImageWrapper": "Navigation-module__1DahEa__dropdownTileImageWrapper",
  "dropdownTileTitle": "Navigation-module__1DahEa__dropdownTileTitle",
  "dropdownTiles": "Navigation-module__1DahEa__dropdownTiles",
  "hamburgerBar": "Navigation-module__1DahEa__hamburgerBar",
  "hamburgerBarHidden": "Navigation-module__1DahEa__hamburgerBarHidden",
  "hamburgerBarOpen": "Navigation-module__1DahEa__hamburgerBarOpen",
  "hamburgerButton": "Navigation-module__1DahEa__hamburgerButton",
  "hamburgerIcon": "Navigation-module__1DahEa__hamburgerIcon",
  "header": "Navigation-module__1DahEa__header",
  "leftSection": "Navigation-module__1DahEa__leftSection",
  "logoWrapper": "Navigation-module__1DahEa__logoWrapper",
  "logoWrapperRegular": "Navigation-module__1DahEa__logoWrapperRegular",
  "logoWrapperSmall": "Navigation-module__1DahEa__logoWrapperSmall",
  "mainNav": "Navigation-module__1DahEa__mainNav",
  "mainNavOpen": "Navigation-module__1DahEa__mainNavOpen",
  "middleCountries": "Navigation-module__1DahEa__middleCountries",
  "middleCountriesList": "Navigation-module__1DahEa__middleCountriesList",
  "middleCountriesTitle": "Navigation-module__1DahEa__middleCountriesTitle",
  "mobileAccountSection": "Navigation-module__1DahEa__mobileAccountSection",
  "mobileControls": "Navigation-module__1DahEa__mobileControls",
  "mobileDropdownContent": "Navigation-module__1DahEa__mobileDropdownContent",
  "mobileDropdownContentExtraBtmPadding": "Navigation-module__1DahEa__mobileDropdownContentExtraBtmPadding",
  "mobileDropdownItem": "Navigation-module__1DahEa__mobileDropdownItem",
  "mobileDropdownItemWrapper": "Navigation-module__1DahEa__mobileDropdownItemWrapper",
  "mobileNavHeader": "Navigation-module__1DahEa__mobileNavHeader",
  "navItem": "Navigation-module__1DahEa__navItem",
  "navLink": "Navigation-module__1DahEa__navLink",
  "navLinkActive": "Navigation-module__1DahEa__navLinkActive",
  "navLinkNoChildren": "Navigation-module__1DahEa__navLinkNoChildren",
  "navLinkText": "Navigation-module__1DahEa__navLinkText",
  "navList": "Navigation-module__1DahEa__navList",
  "partner": "Navigation-module__1DahEa__partner",
  "promotion": "Navigation-module__1DahEa__promotion",
  "regionsNav": "Navigation-module__1DahEa__regionsNav",
  "signInButton": "Navigation-module__1DahEa__signInButton",
  "slideIn": "Navigation-module__1DahEa__slideIn",
  "sticky": "Navigation-module__1DahEa__sticky",
});
